import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownChonDonViChuTriThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName='coQuanQuanLyId' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownChonDonViChuTriThanhTra.defaultProps = {
  label: 'Đơn vị chủ trì',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
}

export default validatable(DropDownChonDonViChuTriThanhTra);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonDonViChuTriThanhTra.jsx